import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";
import state from "./state"

Vue.use(Vuex);

const ignoreState = ["snackbar", "version"]
const paths = Object.keys(state.state).filter(key => !ignoreState.includes(key)).map(key => `state.${key}`)
export default new Vuex.Store({
    modules: {
        state,
    },
    plugins: [createPersistedState(
    {
        key: "localInfo", // ローカルストレージに保存するキーを指定する.
        // ローカルストレージに保存するデータを指定する
        paths
    }
  )]

})
